var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcSortingDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 7,
    viewBox: "0 0 10 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.55808 0.868984L5.02255 4.40452L1.48699 0.868962L0.35562 2.00033L5.02253 6.66724L9.68945 2.00035L8.55808 0.868984Z",
    fill: "#D2D5D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSortingDown);
export default __webpack_public_path__ + "static/media/ic-sorting-down.447a24fb1070770414dfe4826183b8c7.svg";
export { ForwardRef as ReactComponent };